import React from 'react';
import { FastField, Field, FastFieldProps, FieldProps } from 'formik';

export function withField<T>(Component: React.FunctionComponent<T>) {
  return ({
    fast = true,
    ...props
  }: Omit<T, keyof FieldProps | keyof FastFieldProps> & { fast?: boolean }) =>
    fast ? (
      <FastField {...props}>
        {(fastFieldProps: T) => <Component {...fastFieldProps} {...props} />}
      </FastField>
    ) : (
      <Field {...props}>{(fieldProps: T) => <Component {...fieldProps} {...props} />}</Field>
    );
}

